<template>
    <div class="home-page cg-page">
    <div class="pt20">
    <a class="logo" href="/#/index"><img src="static/images/logo1.png" /></a>
    </div>
		<div class="content">
      <div class="drop-down-content">
        <div class="login-content">
          <div class="ac fs33 pt20" style="width:80%;margin:30px auto 30px;color:#ebe8f5;text-transform: uppercase;" v-html="$t('cgtips1')"></div>
          <div class="ac" style="color:#ebe8f5;width:80%;margin:0 auto 40px;">{{$t('cgtips2')}}</div>
          <div class="input-div">
            <div class="span fs33">{{$t('phoneNumber')}}</div>
            <div class="input-item">
              <input class="input" v-model="mobile" disabled placeholder="">
            </div>
          </div>
          <div class="input-div">
            <div class="span fs33">OTP</div>
            <div class="disflex" style="background: none;width: 70%;">
              <div class="input-item ">
                <input class="input" v-model="otp" style="width: 100%;height:70px;" placeholder="">
              </div>
              <button class="btn btn-blue" style="padding: 0 10px;height: 65px;line-height: 40px;min-width: 190px;min-height: 40px;margin: 15px 0 5px 10px;width: auto;" :class="{disable:codeText != $t('getCode')}" type="none" :disabled="codeText != $t('getCode')" @click="getSendOtp">{{codeText}}</button>
            </div>
          </div>
          <div class="ac mt100" style="margin-top:120px;">
            <button class="btn btn-blue btn-blue2"  style="width:calc(70% - 80px);" @click="goLogin">{{$t('Login')}}</button>
          </div>
          <div class="ac otp-b mt100">
            {{$t('cgtips3')}}
            <router-link class="fs33 opt-a " :to="{path:'/termsAndCondition'}">{{$t('TC')}}</router-link>
            {{$t('cgtips4')}}
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/headerNo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        otp:'',
        codeText:'',
        isReturn:false
      }
    },
    created(){
      this.codeText = this.$t('getCode')
      if(this.$route.query.msisdn){
        this.mobile = this.$route.query.msisdn;
        this.getSendOtp();
      }
    },
    methods: {
      getSendOtp(){
        let that = this
        if(that.isReturn){
          return;
        }
        that.isReturn = true
        let data ={
            'mobile':this.$route.query.msisdn
        }
        that.$api.post('/api/user/send_otp',data,r =>{
          that.$utils.alertText(r.msg,80,3000);
          if(r.code == 1){
            this.countDown(61,1)
          }else if( r.code == 4401){
            that.isReturn = false
            // this.$router.push({path:'/land'})
          }else{
            that.isReturn = false
          }
        })
      },
      back(){
        this.$router.go(-1);
      },
      goLogin(){
        let that = this
        if(!that.otp){
          that.$utils.alertText(that.$t('tips'),60)
          return;
        }
        let data ={
            'mobile':this.$route.query.msisdn,
            'otp':this.otp,
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/user/otp_login',data,r =>{
          that.$parent.loadModal(false);
          if(r.code==1){
            localStorage.setItem('token',r.data.userinfo.token)
            that.isShowlogin = false
            that.mobile = ''
            that.otp = ''
            this.$router.push({path:'/'})
          }else{
            that.$utils.alertText(r.msg,80);
          }
        })
      },
      // 计时
      countDown (miao,type){
        if(miao === 1){
          this.codeText = this.$t('getCode');
          return;
        }
        miao--;
        if(type === 1){
          this.codeText = miao + "s";
          this.isReturn = false
        }
        setTimeout(() =>{
          this.countDown(miao,type);
        },1000)
      }
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .input{background:none;height:70px;border:none;border-radius: 20px;font-size:38px;font-family:ChevinProBold;padding:0 20px;width:80%;color: #280933;}
  .input-div{margin:30px 40px 10px;}
  .input-div .span{margin: 0 auto 10px;width:70%;}
  .input-item{background:#ebe8f5;border-radius: 20px;height:80px;line-height:80px;width:70%;margin: 0 auto;background-image: linear-gradient(#ffffff,#dce9f2,#9dc0dc,#bbd3e5);
    border: 4px solid #ccc;}
  .input-div div span{font-size:38px;padding-left: 30px;color: #280933;}
  .mt100{margin-top:100px;}
  .opt-a{color: #2d31fa;text-decoration: underline;}
  .btn{line-height:80px;width:100%;color:#280933;}
  .otp-b{margin:100px 50px 0 ;}
  .cg-page{background:url(../../static/images/bg.jpg) repeat-y center top #7e00dd;color:#fff}
  .btn.disable{filter: grayscale(40%);}
  .btn-blue2{padding: 30px 20px;font-size:40px;}
  .login-content{color:#fff;}
</style>



// WEBPACK FOOTER //
// src/page/otp.vue